import React, {useState} from "react";
import UserImagePopUpWrapper from "./UserImagePopUpWrapper";
import {UserImageMesageDiv} from "./styled";
import {Button} from "../../HTMLEntities/Button";

interface Props {
    setErrorMsg: React.Dispatch<React.SetStateAction<string | null>>;
    errorMsg: string | null;
    disableBack?: boolean;
}
const UserImageErrorLayer: React.FC<Props> = ({setErrorMsg, errorMsg}) => {
    const [show, setShow] = useState(true);

    return (
        <UserImagePopUpWrapper
            show={show}
            enableCross={false}
            closeHandle={() => {
                setShow(false);
            }}
            onAfterClose={() => {
                setErrorMsg(null);
            }}
        >
            <UserImageMesageDiv>
                <p>{errorMsg}</p>
                <Button
                    orange
                    onClick={() => {
                        setShow(false);
                    }}
                    autoWidthPopupBubuttonCSS={{
                        mobile: {width: "auto"},
                        laptop: {width: "auto"},
                    }}
                    tton
                >
                    Ok
                </Button>
            </UserImageMesageDiv>
        </UserImagePopUpWrapper>
    );
};

export default UserImageErrorLayer;
